import { type AccountSummary, SpendAccountCategory } from '@fruitful/types';

export const isLiabilityAccountType = (accountType?: string): boolean =>
    (accountType ?? '').toLowerCase().includes('liability') ||
    (accountType ?? '').toLowerCase() === 'credit' ||
    (accountType ?? '').toLowerCase() === 'loan';

export const getSpendAccountCategory = (
    accountType?: string,
): SpendAccountCategory | undefined => {
    if (accountType == null) return undefined;

    if (isLiabilityAccountType(accountType)) {
        return SpendAccountCategory.CREDIT;
    }

    return SpendAccountCategory.CASH;
};

export const getCashTotalCurrentBalanceCents = (
    accounts: AccountSummary[],
): number => {
    return accounts.reduce(
        (total, account) =>
            total +
            (isLiabilityAccountType(account.type ?? account.rawType)
                ? 0
                : (account.currentBalanceCents ?? 0)),
        0,
    );
};
